import { TApplicationState } from '../../types/redux';
import { IBreadcrumb } from '../../types/newbuilding/breadcrumb';

export function getBreadCrumbs(state: TApplicationState): IBreadcrumb[] {
  const {
    newbuilding: { breadcrumbs },
  } = state;

  if (breadcrumbs && breadcrumbs.length) {
    return breadcrumbs;
  }

  return [];
}
